const documentName = () => {
  const fileInput = document.querySelectorAll(".fileinput");

  if (fileInput) {
    document.querySelectorAll(".container-file-text").forEach(item => item.textContent = "Choisissez un fichier");

    fileInput.forEach((input) => {
      input.addEventListener("change", (e) => {
        e.target.parentNode.querySelector(".container-file-text").textContent = e.target.files[0].name;
      })
    })
  }
}

document.addEventListener("DOMContentLoaded", () => {
  documentName();
});
